import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

// Components
import AppHeader from '../../components/App/AppHeader';
import AdminNav from '../../components/Admin/AdminNav';

class AdminPortal extends Component {
  static propTypes = {
    location: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    screen: PropTypes.object.isRequired
  }

  render() {
    if (!this.props.isLoggedIn) {
      return <Redirect to={{
        pathname: '/login',
        state: { from: this.props.location }
      }}/>
    }
    if (!this.props.user.admin && !this.props.user.super_admin) {
      return <Redirect to={{
        pathname: '/dashboard',
        state: { from: this.props.location }
      }}/>
    }

    return (
      <div className="app-portal">
        <AppHeader
          user={ this.props.user }
          appName={ this.props.appName}
          logoPath="/admin/accounts/"
      />
        <div className="app-portal-canvas">
          <AdminNav
            path={ this.props.location }
          />
            <div className="wrap">
              { this.props.screen }
            </div>
        </div>
      </div>
    );
  }
}

export default AdminPortal;
